<textarea
  #textarea
  [(ngModel)]="value"
  [placeholder]="placeholder"
  [disabled]="disabled"
></textarea>
